import MainNav from './main-nav';
import React from 'react';
import fallbackImage from '../../images/banner/banner-1.jpg';

const Header = (props) => {
    const { headerImage, headerTitle, headerIntro } = props;
    const imageOrFallback = headerImage ? headerImage : fallbackImage;

    return (
        <header className="site-header">
            <a className="u-sr-only skip-to-content" href="#main-content">
                Skip to main content
            </a>
            <div className="banner-bg" style={{ backgroundImage: `url(${imageOrFallback})` }}></div>
            <MainNav />
            <div className="site-header__title">
                <div>
                    {headerTitle ? (
                        <h1 id="main-content" tabIndex="-1">
                            {headerTitle}
                        </h1>
                    ) : (
                        <h1 id="main-content" tabIndex="-1">
                            <span className="u-text-light">2019/20</span> Annual&nbsp;Report <span className="u-text-light">summary</span>
                        </h1>
                    )}
                    <p>
                        {headerIntro
                            ? headerIntro
                            : 'We are proud to work with the community before, during and after emergencies, to help create a safer State. This summary of our Annual Report provides a look at some of the things our people, together with the community have active over the past year.'}
                    </p>
                    <a
                        className="btn btn--primary"
                        target="_blank"
                        href="https://www.dfes.wa.gov.au/publications/Annual%20Reports/DFES_Annual_Report_2019-2020.pdf"
                    >
                        Click here to download our full Annual Report 2019/20
                    </a>
                </div>
            </div>
        </header>
    );
};

export default Header;
